import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { CustomerDetail, QueryOptions } from "./apiEcms.types";

const getCustomer = async (customerId: string, signal: AbortSignal) => {
  const { data } = await apiEcmsHttp.get<CustomerDetail>(
    `/customers/${customerId}`,
    {
      signal,
    },
  );

  return data;
};

export const useGetCustomer = (customerId: string, options?: QueryOptions) => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.CUSTOMER, customerId, currentGroup],
    queryFn: ({ signal }) => getCustomer(customerId, signal),
    enabled: options?.enabled,
  });
};
